<!-- <h1>Test HEading for scroller</h1> -->
<!-- 
@if (view.logos && view.logos.length > 0) {
<section class="border-b-2 border-primary-500">
    <div class="items-center bg-white h-36 p-4 dark:bg-slate-800">
             <div class="inline-flex flex-nowrap overflow-hidden items-center h-25 pt-8 [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)] w-full">
                 <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                    @for (logo of view.logos; track logo) {
                     <li>
                         <img class="h-10 w-auto" [src]="logo.imageUrl" alt="" />
                     </li>
                    }
                 </ul>
                 <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll" aria-hidden="true">
                    @for (logo of view.logos; track logo) {
                        <li>
                            <img class="h-10 w-auto" [src]="logo.imageUrl" alt="" />
                        </li>
                       }
                 </ul>
             </div>
     </div>
</section>
} -->

@if (view.logos && view.logos.length > 0) {
<section class="border-b-2 border-primary-500">
    <div class="items-center bg-white h-36 p-4 dark:bg-slate-800">
             <div class="inline-flex flex-nowrap overflow-hidden items-center h-25 pt-8 [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)] w-full">
                 <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                    @for (logo of view.logos; track logo) {
                     <li>
                         <img class="h-10 w-auto" [src]="logo.imageUrl" alt="" />
                     </li>
                    }
                 </ul>
                 <ul class="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll" aria-hidden="true">
                    @for (logo of view.logos; track logo) {
                        <li>
                            <img class="h-10 w-auto" [src]="logo.logoUrl" alt="" />
                        </li>
                       }
                 </ul>
             </div>
     </div>
</section>
}